import { apiGet } from './client';

export interface AuditFieldChange {
  field: string;
  oldValue: unknown;
  newValue: unknown;
}

export interface AuditTrailEvent {
  id: number;
  subjectType: string;
  subjectId: number;
  state: string | null;
  reason: string | null;
  changes: AuditFieldChange[] | null;
  createdAt: string | null;
  user: {
    id: number;
    email: string;
    firstName: string | null;
    lastName: string | null;
  } | null;
}

export interface AuditTrailResponse {
  data: AuditTrailEvent[];
  meta: {
    total: number;
    limit: number;
    offset: number;
  };
}

export async function getAuditTrail(
  subjectType: string,
  subjectId: number,
  params?: { limit?: number; offset?: number }
): Promise<AuditTrailResponse> {
  const query = new URLSearchParams();
  if (params?.limit) query.set('limit', String(params.limit));
  if (params?.offset) query.set('offset', String(params.offset));
  const qs = query.toString() ? `?${query.toString()}` : '';
  return apiGet<AuditTrailResponse>(`/audit-trail/${subjectType}/${subjectId}${qs}`);
}
